import './style.scss';
import React from 'react';
import OfferCardGridItemComponent from '../OfferCardGridItemComponent';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
const MostViewedOffersComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="MostViewedOffersComponent" />;
  }
  const { items: cards } = props?.fields;
  const { t, i18n, params } = props;
  const lang = i18n.language;

  const shouldRenderCards = !!cards;

  return (
    <div className={clsx('offer-card-grid-items flex-it flex-wrap', 'add-margins', params?.Styles)}>
      {shouldRenderCards &&
        cards?.map((card, iCard) => {
          return <OfferCardGridItemComponent item={card} key={iCard} lang={lang} translate={t} />;
        })}
    </div>
  );
};

export default withTranslation()(MostViewedOffersComponent);
